import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("b3_token");
export const setToken = (t) => localStorage.setItem("b3_token", t);
export const clearToken = () => localStorage.removeItem("b3_token");
export const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const fmtMoney = (cents) =>
  `$${((cents || 0) / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const api = axios.create({ baseURL: API });
